import { Card, CardContent } from '@travellegacy/nexops-design-system';
import { ClockWidget } from '../components/ClockWidget';

export default function PontoPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-foreground">Meu Ponto</h1>
        <p className="text-muted-foreground mt-1">Registre sua entrada, intervalos e saída</p>
      </div>

      {/* Card centralizado — máx 480px para não ficar espalhado */}
      <div className="flex justify-center">
        <Card className="w-full max-w-lg">
          <CardContent className="pt-2 pb-6">
            <ClockWidget />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
